<div class="vz-layout-tpl layout flex">
    <ng-container [ngTemplateOutlet]="tplElement" [ngTemplateOutletContext]="{ $implicit: rootElement() }" />
</div>

@let opt = options();
@let ttd = ttDef();
<ng-template let-tpl #tplElement>
    @switch (tpl.type) {
        @case (LET.Box) {
            <div class="vz-tpl-box" [class]="tpl._classes" [style]="tpl._styles">
                @if (tpl.items?.length) {
                    @for (item of tpl.items; track $index) {
                        <ng-container [ngTemplateOutlet]="tplElement" [ngTemplateOutletContext]="{ $implicit: item }" />
                    }
                }
            </div>
        }
        @case (LET.Icon) {
            <i [class]="tpl._classes" [style]="tpl._styles"></i>
        }
        @case (LET.MenuButton) {
            @if (!tpl.mobileOnly || _mobile()) {
                <button
                    [class.ant-btn-icon-only]="!tpl.text"
                    nz-button
                    [class]="tpl._classes"
                    [style]="tpl._styles"
                    [nzSize]="tpl.vzSize"
                    [nzType]="tpl.vzType"
                    [nzShape]="tpl.vzShape"
                    [title]="tpl.tooltip"
                    (click)="sendEvent($event, 'menuButton', tpl.data)">
                    @if (tpl.icon) {
                        <i [class]="tpl.icon"></i>
                    }
                    @if (tpl.text) {
                        {{ tpl.text }}
                    }
                </button>
            }
        }
        @case (LET.TaskField) {
            @if (tTask(); as task) {
                @let om = objectsMap();
                @let show = fields().show;
                @let ttm = fields().map;
                @switch (tpl.subType) {
                    @case (TFT.ShortId) {
                        <vz-task-id-badge [task]="task" [class]="tpl._classes" [style]="tpl._styles" />
                    }
                    @case (TFT.Subj) {
                        @if (show[TFST.Subj]) {
                            <div class="elli-wrap" style="margin-bottom: 0;"
                                [class]="tpl._classes"
                                [style]="tpl._styles">
                                <div
                                    nz-typography
                                    [nzEllipsis]="!!tpl.maxRows"
                                    [nzEllipsisRows]="tpl.maxRows ? tpl.maxRows : undefined"
                                    [vz-task-text-classes]="task">
                                    @if (task.archived || !task.sprintId) {
                                        <i class="fs-l txt-ll mh025" [class]="task.archived ? 'vzi-done' : 'vzi-stack'" [title]="task.archived ? 'в архиве' : 'отложено'"></i>
                                    }
                                    {{ task.subj }}
                                </div>
                            </div>
                        }
                    }
                    @case (TFT.Creator) {
                        @if (show[TFST.Author]) {
                            <vz-avatar
                                [class]="tpl._classes"
                                [style]="tpl._styles"
                                [uid]="om?.[task.createdBy!] ? undefined : task.createdBy"
                                [item]="om?.[task.createdBy!]"
                                [forceActive]="om?.[task.createdBy!]"
                                [type]="'user'"
                                [noImg]="tpl.userMode == 'text'"
                                [withName]="tpl.userMode != 'icon'"
                                [size]="tpl?.size || 32" />
                        }
                    }
                    @case (TFT.AssignIcon) {
                        @if (show[TFST.Author] && show[TFST.Assignee]) {
                            <i class="vzi-arrow-right" [class]="tpl._classes" [style]="tpl._styles"></i>
                        }
                    }
                    @case (TFT.Assignee) {
                        @if (show[TFST.Assignee]) {
                            <vz-avatar
                                [class]="tpl._classes"
                                [style]="tpl._styles"
                                [uid]="om?.[task.assignee!] || om?.[task.assigneeGroup!] ? undefined : task.assignee || task.assigneeGroup"
                                [item]="om?.[task.assignee!] || om?.[task.assigneeGroup!]"
                                [forceActive]="om?.[task.assignee!] || om?.[task.assigneeGroup!]"
                                [type]="!task.assignee && task.assigneeGroup ? 'group' : 'user'"
                                [noImg]="tpl.userMode == 'text'"
                                [withName]="tpl.userMode != 'icon'"
                                [size]="tpl?.size || 32" />
                        }
                    }
                    @case (TFT.Status) {
                        @if (!opt?.hideStatus) {
                            <div class="layout center" [class]="tpl._classes" [style]="tpl._styles">
                                @if (om?.taskStatus) {
                                    <i class="fs-xl" [class]="om?.taskStatus.icon" [style.color]="om?.taskStatus.color"></i>
                                    @if (!_mobile() && !tpl.noTitle) {
                                        <b class="ml025" [style.color]="om?.taskStatus.color">{{ om?.taskStatus.title }}</b>
                                    }
                                }
                                @else {
                                    @let st = workflow()?._stateMap?.[task.stateId || ''];
                                    @if (st) {
                                        <i class="fs-xl" [class]="st.icon" [style.color]="st.color"></i>
                                        @if (!_mobile() && !tpl.noTitle) {
                                            <b class="ml025" [style.color]="st.color">{{ st.title }}</b>
                                        }
                                    }
                                }
                            </div>
                        }
                    }
                    @case (TFT.Created) {
                        <vz-dt [dt]="task.created" />
                    }
                    @case (TFT.PlannedHours) {
                        @if (task.plannedHours && show[TFST.PlannedHours]) {
                            <small class="layout center gap025">
                                <ng-container [ngTemplateOutlet]="fieldNameTpl" [ngTemplateOutletContext]="{ $implicit: ttm[TFST.PlannedHours] }" />
                                <span>{{ task.plannedHours | dayhours:'' }}</span>
                            </small>
                        }
                    }
                    @case (TFT.Favorite) {
                        <vz-task-favorite [task]="task" [class]="tpl._classes" [style]="tpl._styles" />
                    }
                    @case (TFT.Tags) {
                        @if (task.tags?.length && show[TFST.Tag]) {
                            @for (tid of task.tags; track tid) {
                                <vz-tag
                                    [class]="tpl._classes"
                                    [style]="tpl._styles"
                                    [tagId]="om?.[tid] ? undefined : tid"
                                    [tag]="om?.[tid]"
                                    [tagSize]="tpl.vzSize" />
                            }
                        }
                    }
                    @case (TFT.Priority) {
                        @if (show[TFST.Priority]) {
                            <div class="layout" [class]="tpl._classes" [style]="tpl._styles">
                                @switch (tpl.priority) {
                                    @case ('square') {
                                        <div class="txt-inv"
                                            style="padding: 0 0 0 6px; height: 19px; width: 19px; line-height: 1.3;"
                                            [class]="'task-pr-bg-' + task.priority">
                                            {{ task.priority }}
                                        </div>
                                    }
                                    @default {
                                        <i [class]="'task-flag-' + task.priority"
                                            [class.task-flag-s]="tpl.vzSize == 'small'"
                                            [class.task-flag-l]="tpl.vzSize == 'large'"
                                            [class.task-flag-xl]="tpl.vzSize == 'x-large'"
                                            [title]="'Приоритет: ' + TPN[task.priority || 0]"
                                            style="margin-left: 4px;"></i>
                                    }
                                }
                            </div>
                        }
                    }
                    @case (TFT.Duedate) {
                        @if (task.dueDate && show[TFST.DueDate]) {
                            <small class="txt-l layout center gap025"
                                [class]="tpl._classes"
                                [style]="tpl._styles"
                                [vz-duedate-text-classes]="task">
                                @if (!tpl.noTitle) {
                                    <ng-container [ngTemplateOutlet]="fieldNameTpl" [ngTemplateOutletContext]="{ $implicit: ttm[TFST.DueDate] }" />
                                }
                                <span>{{ task.dueDate | date:'dd.MM.yyyy' }}</span>
                            </small>
                        }
                    }
                    @case (TFT.Unread) {
                        @if ((task.flags && !task.flags.seen) || opt?.allUnread) {
                            <i class="vzi-record anim-pulse txt-ok" [class]="tpl._classes" [style]="tpl._styles"></i>
                        }
                    }
                    @case (TFT.Archived) {
                        @if (task.archived) {
                            <i class="vzi-done" [class]="tpl._classes" [style]="tpl._styles"></i>
                        }
                    }
                    @case (TFT.Links) {
                        @if (task && task.id && task.links && task.links.length && show[TFST.Link]) {
                            @for (link of task.links; track link) {
                                <vz-task-link-badge
                                    [class]="tpl._classes"
                                    [style]="tpl._styles"
                                    [taskId]="task.id"
                                    [link]="link"
                                    [showTooltip]="false"
                                    [showText]="false" />
                            }
                        }
                    }
                    @case (TFT.TypeIcon) {
                        @if (ttd?.icon) {
                            <div class="layout center-center"
                                [class]="tpl._classes"
                                [style]="tpl._styles">
                                <i [class]="ttd?.icon"></i>
                            </div>
                        }
                    }
                    @case (TFT.CustomFields) {
                        @for (cf of fields().custom; track cf._id) {
                            @let fd = cf.fieldDef;
                            @if (cf._id && fd && task.customValues && task.customValues[cf._id] != null) {
                                @let cfVal = task.customValues[cf._id];
                                <div class="layout center gap025" [class]="tpl._classes" [style]="tpl._styles">
                                    @let bool = fd.type == VZPT.Boolean;
                                    @if (cf.icon) {
                                        <i class="fs-xl lh1" [class]="cf.icon" [style.color]="cf.color"></i>
                                        @if (bool) {
                                            <i class="fs-xl lh1" [class]="cfVal ? 'vzi-check txt-ok' : 'vzi-cross txt-err'"></i>
                                        }
                                    }
                                    @else if (cf.name) {
                                        @if (bool) {
                                            <i class="fs-xl lh1" [class]="cfVal ? 'vzi-check txt-ok' : 'vzi-cross txt-err'"></i>
                                        }
                                        <span class="elli" style="max-width: 50%" [style.color]="cf.color">
                                            {{ cf.name }}
                                        </span>
                                        @if (!bool) {
                                            <span class="ml-025" [style.color]="cf.color">:</span>
                                        }
                                    }
                                    @if (fd.type == VZPT.String || fd.type == VZPT.Integer) {
                                        <span class="elli">{{ cfVal }}</span>
                                    }
                                    @else if (fd.type == VZPT.Date) {
                                        <span class="elli">{{ cfVal | date:'dd.MM.yyyy' }}</span>
                                    }
                                    @else if (fd.type == VZPT.Enum) {
                                        <span class="elli">{{ fd._enumMap?.[cfVal] || '?' }}</span>
                                    }
                                </div>
                            }
                        }
                    }
                    @default {
                        <i class="txt-ll">&lt;неизвестный элемент&gt;</i>
                    }
                }
            }
        }
        @default {
            <i class="txt-ll">&lt;неизвестный элемент&gt;</i>
        }
    }
</ng-template>

<ng-template let-block #fieldNameTpl>
    @if (block?.icon) {
        <i class="fs-l lh1" [class]="block.icon" [style.color]="block.color"></i>
    }
    @else if (block?.name) {
        <span [style.color]="block.color">{{ block.name }}:</span>
    }
</ng-template>